/**
 * Prepare HTML for rendering: if content has no HTML tags (legacy plain text),
 * convert newlines to <br/>. Otherwise return as-is (already HTML from editor).
 */
export function prepareHtml(text: string): string {
  if (!text) return ''
  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(text)
  if (!hasHtmlTags) {
    return text.replaceAll('\n', '<br/>')
  }
  return text
}

export function stripHtml(html: string): string {
  if (!html) return ''
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim()
}
